var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"categoria-disciplina","rota-base":"/admin/categoria-disciplina","titulo":"CATEGORIAS DE DISCIPLINA","titulo-singular":"Categoria de Disciplina","colunas-extras":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }